<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>
            Remove as System Admin

        </cll-dialog-title>
        <cll-dialog-subtitle>{{`${user.person.given_name} ${user.person.family_name}`}}</cll-dialog-subtitle>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <span>Are you sure you want to confirm this user’s system admin access removal? </span>
            <span>They will lose all administrative permissions and will no longer be able to manage system settings.</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="this.removeSystemAdminRequest.loading()"
                (click)="remove()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
